import styled from "styled-components";

const HeaderActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`

export default HeaderActions